// Site-wide facts used by the footer and info pages.
export const SITE = {
  name: 'PokerNow AI',
  company: 'RD Technologies LLC',
  founder: 'Ronney Do',
  github: 'https://github.com/Ronney221/pokerNOWAI',
  linkedin: 'https://www.linkedin.com/in/ronneydo',
  // Set to a monitored inbox to show it on the Contact page and in the legal pages.
  contactEmail: '',
};
